"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveSubprojectModal = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var actions = require("@caddigital/sok-reducers/lib/actions/subproject");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var components_1 = require("components");
var mapStateToProps = function (state) { return ({
    subproject: state.subproject
}); };
var mapDispatchToProps = function (dispatch) { return ({
    archive: function (payload) {
        return dispatch(actions.archive.archiveRequest(payload));
    },
    fetchGroups: function (subproject) {
        return subproject &&
            dispatch(actions.usergroupList.fetchRequest('SUBPROJECT', subproject.id, {
                includeMembers: 'false'
            }));
    },
    setPermissionRemove: function (status) {
        return dispatch(actions.archive.setPermissionSelection(status));
    },
    selectCategory: function (category) {
        return dispatch(actions.archive.toggleCategory(category));
    },
    clear: function () { return (dispatch(actions.usergroupList.clear()), dispatch(actions.archive.clear())); }
}); };
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ArchiveSubprojectModal'), (0, recompose_1.withState)('categories', 'setCategories', []), (0, recompose_1.withState)('showRemove', 'setShowRemove', false), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.subprojectIsOpen && this.props.selected) {
            this.props.fetchGroups(this.props.selected);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.subprojectIsOpen) {
            if (this.props.subprojectIsOpen !== prevProps.subprojectIsOpen ||
                this.props.selected !== prevProps.selected) {
                this.props.fetchGroups(this.props.selected);
            }
            if (this.props.subproject.archive.status === 'FETCHED' &&
                this.props.subproject.archive.status !==
                    prevProps.subproject.archive.status) {
                this.props.setSubprojectIsOpen(false);
            }
            if (this.props.subproject.usergroups.groups !==
                prevProps.subproject.usergroups.groups) {
                var _a = this.props.subproject.usergroups.groups.reduce(function (acc, row) {
                    if (row.category.type === 'CustomerCategoryUserGroup') {
                        row.groups.sort(function (a, b) { return a.name.localeCompare(b.name); });
                        acc.rows.push(row);
                    }
                    else if (acc.showRemove === false &&
                        row.category.type === 'CategoryUserGroup') {
                        if (row.groups.findIndex(function (x) { return x.type === 'NormalUserGroup'; }) >
                            -1) {
                            acc.showRemove = true;
                        }
                    }
                    return acc;
                }, { showRemove: false, rows: [] }), showRemove = _a.showRemove, rows = _a.rows;
                rows.sort(function (a, b) { return a.category.name.localeCompare(b.category.name); });
                this.props.setShowRemove(showRemove);
                this.props.setCategories(rows);
            }
        }
        else {
            if (this.props.subprojectIsOpen !== prevProps.subprojectIsOpen) {
                this.props.clear();
            }
        }
    }
}), recompose_1.pure);
var RowItem = function (props) {
    var cat = props.item.category;
    var groups = props.item.groups;
    return (React.createElement("div", { className: 'category-row' },
        React.createElement("div", { className: 'icon' },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', className: props.selected ? 'selected' : undefined, onClick: function () { return props.select(cat); } })),
        React.createElement("div", { className: 'name' },
            React.createElement("div", null, cat.name),
            React.createElement("ul", null, groups.map(function (group) { return (React.createElement("li", { key: "".concat(group.id) }, group.name)); })))));
};
exports.ArchiveSubprojectModal = enhance(function (props) {
    return (React.createElement(sok_ui_1.Overlay, { isOpen: props.subprojectIsOpen },
        React.createElement(sok_ui_1.SideMenu, { className: 'subproject-sidemenu archive', isOpen: props.subprojectIsOpen, docked: false, orientation: 'right' },
            React.createElement(sok_ui_1.Header, { onClose: function () { return props.setSubprojectIsOpen(false); } }, (0, translation_1.getLocalization)('fileListTools/archiveSubproject/header')),
            React.createElement(sok_ui_1.Container, null,
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.subproject.archive.status, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
                    (0, translation_1.getLocalization)('subproject/archive/status/saving'),
                    (0, translation_1.getLocalization)('subproject/archive/status/saved'),
                    (0, translation_1.getLocalization)('subproject/archive/status/failed')),
                React.createElement("div", { className: 'disclaimer' }, (0, translation_1.getLocalization)("fileListTools/archiveSubproject/disclaimer")),
                props.subproject.usergroups.status === 'FETCHING' && (React.createElement("div", { className: 'center' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.subproject.usergroups.status === 'FAILED' && (React.createElement("div", { className: 'center' },
                    React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetchGroups(props.selected); } })))),
                props.subproject.usergroups.status === 'FETCHED' && (React.createElement(React.Fragment, null,
                    React.createElement("label", { key: 'remove-all-label' }, (0, translation_1.getLocalization)('fileListTools/archiveSubproject/removeAllAccess')),
                    props.showRemove ? (React.createElement("div", { key: 'remove-all', className: 'remove-all-access' },
                        React.createElement(sok_ui_1.Input, { type: 'radio', value: props.subproject.archive.removePermissions, label: (0, translation_1.getLocalization)('global/yes'), onChange: function () { return props.setPermissionRemove(true); } }),
                        React.createElement(sok_ui_1.Input, { type: 'radio', value: !props.subproject.archive.removePermissions, label: (0, translation_1.getLocalization)('global/no'), onChange: function () { return props.setPermissionRemove(false); } }))) : (React.createElement("div", { key: 'remove-all', className: 'remove-all-access' },
                        React.createElement("i", null, (0, translation_1.getLocalization)('fileListTools/archiveSubproject/noUserGroups')))),
                    React.createElement("label", { key: 'categories-label' }, (0, translation_1.getLocalization)('fileListTools/archiveSubproject/selectArchiveCategories')),
                    React.createElement("div", { key: 'categories', className: 'cateogries' }, props.categories.length > 0 ? (props.categories.map(function (item) { return (React.createElement(RowItem, { key: "".concat(item.category.id), item: item, selected: props.subproject.archive.categories[item.category.id] !== undefined, select: props.selectCategory })); })) : (React.createElement("i", null, (0, translation_1.getLocalization)('fileListTools/archiveSubproject/noArchiveCategories'))))))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { color: 'green', iconRight: React.createElement(Icon_1.Icon, { className: 'fa-piggy-bank' }), text: (0, translation_1.getLocalization)('buttons/save'), disabled: props.subproject.archive.status === 'FETCHING', onClick: function () {
                        if (props.selected === null || props.selected.type !== 'FOLDER') {
                            return;
                        }
                        var archive = props.subproject.archive;
                        var categories = Object.values(archive.categories);
                        props.archive({
                            subproject: props.selected,
                            removePermissions: archive.removePermissions,
                            archiveGroups: categories.map(function (x) { return x.id; })
                        });
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', iconRight: React.createElement(Icon_1.Icon, { className: 'fa-times-circle' }), text: (0, translation_1.getLocalization)('buttons/cancel'), disabled: props.subproject.archive.status === 'FETCHING', onClick: function () { return props.setSubprojectIsOpen(false); } })))));
});
